import React from 'react'

import { Swiper, SwiperSlide } from 'swiper/react'
import {Navigation, Pagination} from 'swiper'
import 'swiper/css/pagination'
import './fiveMirea.css'
import { fiveStepsMirea } from '../../../../routes/fiveStepsMirea'

import styles from './styles.module.scss'
import {fiveSteps} from "../../../../routes";
import parse from "html-react-parser";

const FiveStepsMirea = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_block}>
        <div className={styles.left}>
          <p className={styles.title}>Как попасть на программу?</p>
        </div>
        <div className={styles.right}>
          <p className={styles.title}>
            Этапы отбора кандидатов
          </p>
          <div className={styles.slider_block}>
            <div className="slider_mirea_mod_fs">
              <Swiper
                spaceBetween={10}
                initialSlide={0}
                slidesPerView={1}
                slideToClickedSlide
                navigation
                modules={[Navigation]}
              >
                {fiveStepsMirea.map(item => (
                  <SwiperSlide key={item.id}>
                    <div className='wrapper-block'>
                      <div className='wrapper-block-left'>
                        <div className='wrapper-block-left-img'>
                          <p className='wrapper-block-left-img-p'></p>
                          <p className='wrapper-block-left-img-id'>{item.id}</p>
                        </div>
                        <p className='wrapper-block-title' style={{ maxWidth: '80%' }}>
                          {<>{parse(item.title)}</>}
                          <p className='wrapper-block-title2'><span>{item.date}</span></p>
                        </p>
                      </div>
                      <p className='wrapper-block-text'>
                        <span>{item.text}</span>
                      </p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FiveStepsMirea
